import { atom } from 'jotai';

export const selectedStockItemIdsAtom = atom<string[]>([]);

export const setSelectedStockItemIdsAtom = atom(
  null,
  (get, set, ids: string[]) => {
    set(selectedStockItemIdsAtom, [...new Set(ids)]); // Ensure unique IDs
  }
);

export const clearSelectedStockItemsAtom = atom(
  null,
  (get, set) => {
    set(selectedStockItemIdsAtom, []);
  }
);
